document.addEventListener("DOMContentLoaded", async () => {
    const { initFixedAnchorLink } = await import("../components/anchorlink.js");
    initFixedAnchorLink();

    const popupEl = document.querySelector(".popup-detail");
    if (popupEl) {
        const { openPopup } = await import("../components/modal.js");
        openPopup();
    }

    // Banner Support Slider
    const bannerEls = document.querySelector(".js-slider-banner-support");

    if (bannerEls) {
        const { renderSpBannerSlider } = await import("../components/slider.js");
        renderSpBannerSlider(bannerEls);
    }

     // Graduate Slider
    const sliderGraduateEls = document.querySelectorAll(".js-graduate-slider");
    if (sliderGraduateEls.length > 0) {
        const { renderGraduateHome } = await import("../components/slider.js");
        const { PaginationProgress } = await import("../components/pagination-progress.js");

        sliderGraduateEls.forEach((el) => {
            const splide = renderGraduateHome(el);
            if (!splide) return;

            const pagination = new PaginationProgress(
                splide.root.querySelector(".splide__pagination")
            );

            const DURATION = 5000;
            const INTERVAL = 100;
            let timer = null;
            let elapsed = 0;
            let isVisible = false;

            const startProgress = () => {
                if (!isVisible) return;
                pagination.resetAll();

                const activeIndex = splide.index;
                elapsed = 0;
                clearInterval(timer);

                timer = setInterval(() => {
                    if (!isVisible) return;

                    elapsed += INTERVAL;
                    const percent = Math.min((elapsed / DURATION) * 100, 100);
                    pagination.setProgress(activeIndex, percent);

                    if (percent >= 100) {
                        clearInterval(timer);
                        setTimeout(() => {
                            splide.go(">");
                        }, 150);
                    }
                }, INTERVAL);
            };

            const stopProgress = () => {
                clearInterval(timer);
                timer = null;
            };

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            isVisible = true;
                            startProgress();
                        } else {
                            isVisible = false;
                            stopProgress();
                        }
                    });
                },
                { threshold: 0.3 }
            );
            observer.observe(el);

            splide.on("moved", () => {
                clearInterval(timer);
                startProgress();
            });

            window.addEventListener(
                "resize",
                () => {
                    pagination.refresh();
                    clearInterval(timer);
                    startProgress();
                },
                { passive: true }
            );

            splide.on("mounted", () => {
                setTimeout(() => startProgress(), 400);
            });
        });
    }

    const visitorEls = document.querySelectorAll(".js-visitor-slider");
    const { renderVisitorSlider } = await import("../components/slider.js");
    visitorEls.forEach((el) => {
        renderVisitorSlider(el);
    });

    const matchHeightEl = document.querySelector("[data-mh]");
    if (matchHeightEl) {
        const { matchHeightAll } = await import("../components/match-height.js");
        matchHeightAll(false);
    }

    // Close popup when click close button
    const { closePopupBanner } = await import('../components/popup.js');
    closePopupBanner();
    
    // Popup banner suppression (session + cookie based)
    const { initPopupBanner } = await import('../components/popup-banner.js');
    initPopupBanner();
});
